import { URLS } from '../../../constants';
import apiClient from '../../client';
const ClaimInboxGridApi = {
    inboxGrid: ({
        heading,
        roleId,
        type,
        assignedTo,
        pagination,
        order,
        name,
        serachValue,
        searchKey,
        filterValue,
    }: {
        heading: string;
        roleId: string;
        type: string;
        assignedTo: string;
        pagination: {
            startIndex: number;
            noOfRecords: number;
        };
        name: string;
        order: string;
        filterValue: any;
        serachValue?: any;
        searchKey?: any;
        filterType?: any;
    }) => {
        let otherFilterData = [];
        if (serachValue) {
            otherFilterData.push({
                filterKey: searchKey || '',
                filterValue: serachValue ? serachValue : '',
            });
        }
        if (typeof filterValue !== 'string') {
            otherFilterData = [...otherFilterData];
        } else if (typeof filterValue === 'string' && filterValue.length > 0) {
            otherFilterData.push({
                filterKey: '',
                filterValue: serachValue ? serachValue : '',
            });
        }
        return apiClient.post(URLS.inboxGridApi, {
            data: {
                heading,
                roleId,
                type,
                pagination,
                assignedTo,
                filter: typeof filterValue !== 'string' ? filterValue : [],
                otherFilterData,
                sorting: {
                    order: order || 'DESC',
                    fieldName: name || 'modifiedOn',
                },
            },
        });
    },
    deletedClaim: ({
        heading,
        roleId,
        type,
        assignedTo,
        pagination,
        order,
        name,
        filterValue,
    }: {
        heading: string;
        roleId: string;
        type: string;
        assignedTo: string;
        pagination: {
            startIndex: number;
            noOfRecords: number;
        };
        name: string;
        order: string;
        filterValue: any;
    }) =>
        apiClient.post(URLS.deletedClaimGrid, {
            data: {
                heading,
                roleId,
                type,
                pagination,
                assignedTo,
                filterType: filterValue?.[0]?.filterValue?.length
                    ? 'dateFilter'
                    : '',
                filter: filterValue?.[0]?.filterValue?.length
                    ? filterValue
                    : [
                          {
                              filterKey: '',
                              filterValue: '',
                          },
                      ],
                sorting: {
                    order: order || 'DESC',
                    fieldName: name || 'deletedOn',
                },
            },
        }),
    getCMSFormsData: (claimIds: string[] | number[]) => {
        return apiClient.post(URLS.getCMSFormsData, {
            data: {
                claimIds,
            },
        });
    },
    getExportHistoryByClaimId: (claimId: string) => {
        return apiClient.post(URLS.getExportHistoryByClaimId, {
            data: {
                claimId,
            },
        });
    },
    getExportedDocumentById: (id: string) => {
        return apiClient.post(URLS.getExportedDocumentById, {
            data: {
                id,
            },
        });
    },
    saveClaimsDownloadData: (claims: any) => {
        return apiClient.post(URLS.saveClaimsDownloadData, {
            data: {
                claims,
            },
        });
    },
    globalSearch: (searchString: string, dateFilters: any, type: any) => {
        let dateRange = null;
        if (Object.keys(dateFilters).length) {
            dateRange = {
                startDate: dateFilters[0].filterValue,
                endDate: dateFilters[1].filterValue,
            };
        }
        return apiClient.post(URLS.globalClaimsSearch, {
            data: {
                searchString,
                ...dateRange,
                type,
            },
        });
    },
};
export default ClaimInboxGridApi;
